import classnames from 'classnames';
import { LoaderCircleIcon } from 'lucide-react';
import { useEffect, useRef } from 'react';
import party from 'party-js';

import Card from '../../../components/card/card';
import styles from '../redeem-gift-card.module.scss';
import SuccessfulIcon from '../../../assets/images/successful.svg';
import Button from '../../../components/button/button';

type Props = {
    currentStep: number;
    success: boolean;
    onGoHome: () => void;
};

const RedeemingCard = ({ currentStep, success, onGoHome }: Props) => {
    const confettiImgRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        if (success) {
            party.confetti(confettiImgRef.current!, { count: 100 });
        }
    }, [success]);

    return (
        <Card
            className={classnames({
                [styles.card]: true,
                [styles.redeemingCard]: true,
                [styles.shown]: currentStep === 3,
            })}
        >
            <header>
                <h4>{success ? '¡Todo listo!' : 'Canjeando tu suscripción'}</h4>
                <span className={styles.content}>
                    {success
                        ? '¡Felicidades! Has canjeado tu cupón y obtenido una suscripción PANA'
                        : 'Estamos preparando todo para activar tu suscripción lo antes posible'}
                </span>
            </header>
            {success ? (
                <>
                    <div className={styles.successContainer}>
                        <img
                            ref={confettiImgRef}
                            src={SuccessfulIcon}
                            style={{ width: 120 }}
                        />
                    </div>
                    <Button text="Volver al Home" onClick={onGoHome} />
                </>
            ) : (
                <div className={styles.loaderContainer}>
                    <LoaderCircleIcon
                        color="#07bf41"
                        size={48}
                        className={styles.loader}
                    />
                </div>
            )}
        </Card>
    );
};

export default RedeemingCard;
